<template>
  <div>
    <h1>Route Hello world</h1>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld'
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/HelloWorld.vue